import { useLayer } from '@coursera-web/statsig';

import type { EnterpriseSearchBarConfig } from 'bundles/search-common/components/searchbar/searchBarWrapperTypes';

/**
 * Whether the autocomplete card is picked by the backend (QAC guided product), falling back to the products
 * request when it has no pick (SEARCH-2460).
 *
 * The layer is only read for consumer traffic once a direct-match card is possible (query length >= 3), so
 * enterprise users and users who never type enough to see a card log no exposure.
 */
export const useQacGuidedProductEnabled = (
  enterpriseSearchBarConfig: EnterpriseSearchBarConfig | undefined,
  isEligibleForDirectMatch: boolean
): boolean => {
  const autocompleteLayer = useLayer('search-autocomplete');

  return (
    !enterpriseSearchBarConfig && isEligibleForDirectMatch && autocompleteLayer.get('enable_qac_guided_product', false)
  );
};
